import { datadogLogs } from '@datadog/browser-logs'

if (process.env.VUE_APP_ENV !== 'local') {
  datadogLogs.init({
    clientToken: process.env.VUE_APP_DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    env: process.env.VUE_APP_ENV || 'local'
  })
}
